// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pcos","buttons":"styles_buttons__3avTm"};